import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import style from "./Footer.module.scss";
import classnames from "classnames";
import { Mode } from "../../../../utils/Order/Order";
import { Dispatch } from "../store/store";

const Footer = ({ actions, mode, side, buttons, wizzard }) => {
  const { dispatch } = useContext(Dispatch);
  const { precheck, modify, confirm, save } = buttons;

  return (
    <div className={style.footer}>
      <GoStepBack wizzard={wizzard} dispatch={dispatch} />
      <div className={style.buttons}>
        <Button color="light" onClick={actions.toggle}>
          {mode == Mode.EDIT ? "Cancel" : "Close"}
        </Button>{" "}
        {confirm.visible && !wizzard.enabled && (
          <LaddaButton
            className={classnames("btn btn-ladda", side == "Buy" ? style.buy : style.sell)}
            loading={confirm.loading}
            onClick={actions.confirm}
            data-style={EXPAND_RIGHT}
          >
            {confirm.label}
          </LaddaButton>
        )}
      </div>
    </div>
  );
};

const onChangeMode = (dispatch, mode) => dispatch({ type: "CHANGE_MODE", mode });

const GoStepBack = ({ wizzard, dispatch }) => {
  if (wizzard.enabled && wizzard.activeStep != 0) {
    return (
      <Button color="light" onClick={() => dispatch({ type: "WIZZ_STEP_BACK" })}>
        <i className="fa fa-angle-left"></i>
        {"\u00A0"}
        Back
      </Button>
    );
  } else return null;
};

export default Footer;
